import ArticleHero from '/react4xp/components/prototype/ArticleHero'
import Button from '/react4xp/components/prototype/Button'
import ArrowRight from '/react4xp/components/prototype/icons/ArrowRight'
import ArrowUpRight from '/react4xp/components/prototype/icons/ArrowUpRight'

import type { EventProps } from './types'

export default function Event({ title, intro, image, infoPanel }: EventProps) {
	const { date: dateLabel = 'Dato:', time: timeLabel = 'Tid:', venue: venueLabel = 'Sted:' } = infoPanel?.labels ?? {}

	return (
		<div>
			<ArticleHero title={title} intro={intro} image={image} variant="event" />

			{infoPanel && (
				<div className="container py-6">
					<div className="bg-brand-50 flex flex-col items-start gap-6 px-6 py-8 lg:flex-row lg:items-center lg:px-16">
						<div className="flex flex-1 flex-col gap-3.75">
							{infoPanel.location && (
								<h2 className="h4 text-black-950">
									{infoPanel.location.href ? (
										<a
											href={infoPanel.location.href}
											target={infoPanel.location.isExternal ? '_blank' : undefined}
											rel={infoPanel.location.isExternal ? 'noopener noreferrer' : undefined}
										>
											{infoPanel.location.name}
										</a>
									) : (
										infoPanel.location.name
									)}
								</h2>
							)}

							{(infoPanel.date || infoPanel.time || infoPanel.venue || infoPanel.price) && (
								<div className="flex flex-col">
									{infoPanel.date && (
										<p className="body-xl text-black-950">
											<span className="font-semibold">{dateLabel}</span> {infoPanel.date}
										</p>
									)}

									{infoPanel.time && (
										<p className="body-xl text-black-950">
											<span className="font-semibold">{timeLabel}</span> {infoPanel.time}
											{infoPanel.doorsOpenNote && ` (${infoPanel.doorsOpenNote})`}
										</p>
									)}

									{infoPanel.venue && (
										<p className="body-xl text-black-950">
											<span className="font-semibold">{venueLabel}</span> {infoPanel.venue}
										</p>
									)}

									{infoPanel.price && <p className="body-xl text-black-950 italic">{infoPanel.price}</p>}
								</div>
							)}
						</div>

						{(infoPanel.signUp || infoPanel.secondaryButton?.href) && (
							<div className="flex shrink-0 flex-row flex-wrap gap-4 lg:flex-col lg:flex-nowrap">
								{infoPanel.signUp &&
									(infoPanel.signUp.disabled ? (
										<Button variant="primary" disabled>
											{infoPanel.signUp.label ?? 'Sign up'}
											{infoPanel.signUp.href && (infoPanel.signUp.isExternal ? (
												<ArrowUpRight className="h-[1lh] w-5 shrink-0" aria-hidden="true" />
											) : (
												<ArrowRight className="h-[1lh] w-5 shrink-0" aria-hidden="true" />
											))}
										</Button>
									) : (
										<Button variant="primary" href={infoPanel.signUp.href} isExternal={infoPanel.signUp.isExternal}>
											{infoPanel.signUp.label ?? 'Sign up'}
											{infoPanel.signUp.href && (infoPanel.signUp.isExternal ? (
												<ArrowUpRight className="h-[1lh] w-5 shrink-0" aria-hidden="true" />
											) : (
												<ArrowRight className="h-[1lh] w-5 shrink-0" aria-hidden="true" />
											))}
										</Button>
									))}

								{infoPanel.secondaryButton?.href && (
									<Button
										variant="secondary"
										href={infoPanel.secondaryButton.href}
										isExternal={infoPanel.secondaryButton.isExternal}
									>
										{infoPanel.secondaryButton.label ?? 'Watch recording'}
										{infoPanel.secondaryButton.isExternal ? (
											<ArrowUpRight className="h-[1lh] w-5 shrink-0" aria-hidden="true" />
										) : (
											<ArrowRight className="h-[1lh] w-5 shrink-0" aria-hidden="true" />
										)}
									</Button>
								)}
							</div>
						)}
					</div>
				</div>
			)}
		</div>
	)
}
